export default {
  socialConnectIcons: {
    container: 'copy-link-section relative',
    iconStyles: 'social-icon w-15 h-15',
    button:
      'socialicon-btn bg-white rounded-full sm:w-80 lg:w-auto lg:h-50 lg:flex lg:items-center lg:justify-content lg:mb-0 relative sm:pb-30 lg:pb-19 px-15',
  },
  copied: 'copied absolute bg-white p-10 text-grey rounded-lg left-50p-80',
  colseBtn:
    'social-close-btn text-green-dark text-center text-16 w-full lg:cursor-pointer mt-10 pt-15 border-t border-spmenu-border',
  heading: 'social-share-heading pb-20 text-default text-left text-28 w-full',
  socailLink: 'socail-link block no-underline',
  socialDialog: 'social-dialog',
  appText: 'text-xs leading-20',
  socialShare: {
    iconStyles: 'share-icon w-15 h-15',
    button:
      'shareicon-btn bg-white rounded-full px-9 py-7 border border-green-lighter outline-none',
  },
  copyDialog: {
    wrapper: '',
    inputText: 'input border border-note text-default text-20 pl-10 py-5',
    btn: '',
  },
  navDialog: {
    container: 'nav-dialog',
  },
  socialDialogWrapper:
    'social-modal sm:fixed md:absolute bottom-0 left-0 bg-white sm:w-full md:w-auto justify-center lg:py-20 md:h-auto socialShareDiague',
  dialogWrapper:
    'dialogWrapper flex flex-wrap sm:fixed md:relative mx-auto bottom-0 bg-white sm:w-250 md:w-auto sm:pt-30 md:pt-19 md:px-20',
  imageWrappingDiv:
    'imageWrappingDiv bg-lightGrey w-52 py-14 flex justify-center mb-5 rounded-full',
  articlePageStyle: 'articlePageStyle',
};
